module.exports = __webpack_public_path__ + "static/media/flowers.45690168.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/flowers.png
// module id = 49
// module chunks = 0